

// リストページのスライダー
var swiper_our_models = new Swiper(".swiper-our-models", {
    loop: true,
    slidesPerView: 1.5,
    spaceBetween: 20,
    centeredSlides: false,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
});
// リストページのスライダーの縦幅調整
$(function () {
    $('.p-list__our-models__item').matchHeight();
});


